import { render } from "./Festivals.vue?vue&type=template&id=57c75730&scoped=true"
import script from "./Festivals.vue?vue&type=script&lang=js"
export * from "./Festivals.vue?vue&type=script&lang=js"

import "./Festivals.vue?vue&type=style&index=0&id=57c75730&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c75730"]])

export default __exports__